import React, { useState } from 'react';
import { useAlert } from 'react-alert';
import { Auth } from 'aws-amplify';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { Button, ButtonActionBack, DivActionBack, Form, FormControl, H1, Hint, ImgIconBack, InputError } from '../../assets/styles/GlobalStyles';
import { passwordValidation, verifyError } from '../../utils/verifyErrors';
import { Input } from '../../components/Base/Elements';
import IconBack from "../../assets/icon/icon-back.svg";
import { BgSelectAppWebForm, LogoContainer } from "../../components/Base/styled";
import LogoAppWebSelectFarm from "../../assets/images/fundo-rosa-cima.png";
import InputMasked from 'react-input-mask';
import { translate } from '../../i18n/index';

const PasswordRecoveryStore = ({ history }) => {
    const alert = useAlert();
    const hasUsername = history.location.state ? history.location.state.username : null;
    const [passwordValidate, setPasswordValidate] = useState({
        min: false,
        number: false,
    });

    function handleClickForgotPassword() {
        history.push({
            pathname: '/login',
            search: history.location.search,
        });
    }

    return (
        <>
            <DivActionBack>
                <ButtonActionBack onClick={() => handleClickForgotPassword()} type="button">
                    <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
                </ButtonActionBack>
            </DivActionBack>
            <div>
                <LogoContainer
                    style={{ alignSelf: 'center' }}
                    rel="noopener noreferrer"
                    target="_self">
                    <BgSelectAppWebForm src={LogoAppWebSelectFarm} alt="Logo OnFarm" title="OnFarm" />
                </LogoContainer>
            </div>
            <Base width={430} marginTop="450" isAppWeb={true} backgroundForm={'#fff'}>
                <ContentContainer>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            username: hasUsername,
                            code: '',
                            password: '',
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().required(translate('validateRequired')),
                            code: Yup.string()
                                .required(translate('validateRequired'))
                                .matches(/[0-9]/, translate('validateCodeOnlyNumber')),
                            password: Yup.string()
                                .required(translate('validateRequired'))
                                .min(6, translate('validatePasswordMin'))
                                .max(6, translate('validatePasswordMax'))
                                .matches(/^\d+$/, translate('validatePasswordOnlyNumbers'))
                        })}
                        onSubmit={async (values, actions) => {
                            if (values) {
                                try {
                                    await Auth.forgotPasswordSubmit(values.username, values.code, values.password);
                                    alert.show(translate('forgotPasswordExceptionPasswordChangedSuccessfully'), {
                                        closeCopy: 'Fechar',
                                        onClose: async () => {
                                            await Auth.signIn(values.username, values.password);
                                            history.push({
                                                pathname: '/login',
                                                search: history.location.search,
                                                state: {
                                                    email: values.username,
                                                },
                                            });
                                        },
                                    });
                                } catch (e) {
                                    alert.show(verifyError(e.code, e.message), {
                                        closeCopy: 'Fechar',
                                    });
                                }
                            }
                            actions.setSubmitting(false);
                        }}>
                        {({ isSubmitting }) => (
                            <Form>
                                <H1
                                    style={{
                                        marginBottom: '20px',
                                        lineHeight: '25px',
                                        fontSize: '15px',
                                    }}
                                >
                                    {translate('passwordRecoveryTitle')}
                                </H1>

                                <FormControl>
                                    <Field
                                        name="username"
                                        placeholder={translate('inputUsername')}
                                        disabled
                                        component={Input}
                                    />
                                    <ErrorMessage name="username" component={InputError} />
                                </FormControl>

                                <>
                                    <FormControl>
                                        <Field name="code">
                                            {({ field }) => (
                                                <InputMasked
                                                    {...field}
                                                    placeholder={translate('inputCode')}
                                                    maskChar=""
                                                    mask="999999">
                                                    {(inputProps) => <Input {...inputProps} />}
                                                </InputMasked>
                                            )}
                                        </Field>
                                        <ErrorMessage name="code" component={InputError} />
                                    </FormControl>

                                    <FormControl>
                                        <Field
                                            type="password"
                                            name="password"
                                            onInput={(value) => {
                                                passwordValidation(value.target.value, setPasswordValidate);
                                            }}
                                            placeholder={translate('inputNewPassword')}
                                            component={Input}
                                        />
                                        <ErrorMessage name="password" component={InputError} />
                                        <Hint>
                                            <div>{translate('inputPasswordHintTitle')}</div>
                                            <ul>
                                                <li className={`${passwordValidate.min ? 'complete' : ''}`}>
                                                    {translate('inputPasswordHint1')}
                                                </li>
                                            </ul>
                                        </Hint>
                                    </FormControl>
                                </>

                                <FormControl>
                                    <Button type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? translate('buttonSending') : translate('buttonSend')}
                                    </Button>
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </ContentContainer>
            </Base>
        </>
    );
};

export default PasswordRecoveryStore;
